<template>
  <div class="page">
    <div class="t-bg">
      <div class="top-back">
        <div class="back"><img src="@/assets/newUser/mobile.png"></div>
        <div class="code">
          <div style="flex-direction: row;">
            <!-- <van-tag type="success" size="mini">未实名</van-tag> -->
            <span>卡号：{{ recordLoginText }}</span>
          </div>
          <div class="addOrChange">
            <div class="u-switch" @click="popupShow">卡板切换</div>
            <div class="u-switch u-p" @click="toAddSim">添加卡板</div>
          </div>
        </div>
      </div>
      <div class="grille van-top">
        <!-- @click="pkgListVisible = true"  套餐详情-->
        <span>
          <div class="t-f">
            <div class="t-l">
              <span>{{ simInfo.usePkgName }}<span></span></span>

            </div>
            <!-- <div class="t-r" v-if="simInfo.endTimeDay > 2">套餐有效期 <span>套餐时间充足</span></div>   v-else-->
            <div class="t-rRed">套餐有效期 <span>{{ simInfo.endTimeString }}</span></div>
          </div>
          <div class="flowInfo">
            <canvas id="home_progressBar" width="900" height="900"></canvas>
            <div class="residue-flow">
              <p style="font-size: 1.3rem; padding-bottom: .5rem">
                {{ simInfo.cardStateName }}
              </p>
              <p style="font-size: 0.85rem; padding-bottom: 1rem">卡状态</p>
            </div>
          </div>
          <div class="total-liu">
            <div class="l-l">总流量<span>{{ fluxMtoG(simInfo.flowRate || 0) }}G</span></div>
            <div class="l-l">剩余流量<span>{{ fluxMtoG(simInfo.surplusFlowRate || 0) }}G</span></div>
            <div class="l-l">已使用<span>{{ fluxMtoG((simInfo.flowRate * 1 - simInfo.surplusFlowRate * 1) || 0) }}G</span>
            </div>
          </div>
        </span>

        <div class="user-price" v-if="isShieldAgent">
          <div class="price-l">合约余额</div>
          <div class="price-r">
            <div class="text-num">￥{{ simInfo.depositPrice }}</div>
            <div class="text-link" @click="detailsTo">查询详情</div>
          </div>
        </div>
      </div>
      <!-- <div class="v-btn">
        <div class="btn-left">
          <div class="l-icon">
            <van-icon name="warning" size="30"/>
          </div>
          <div class="n-data">
            <div class="n-title">检测到您未充值套餐</div>
            <div class="n-small">充值套餐才可以正常上网哦</div>
          </div>
        </div>
        <div class="btn-right">
          <van-button plain type="primary"  size="small">立即充值</van-button>
        </div>
      </div> -->
      <div class="grille">
        <div class="grille-item" @click="toBalanceRecharge">
          <div class="img-1">
            <img src="@/assets/newUser/1_1.png" alt="">
          </div>
          <div class="icon-text">套餐订购</div>
        </div>

        <div class="grille-item" @click="toRecharge">
          <div class="img-1">
            <img src="@/assets/newUser/2_1.png" alt="">
          </div>
          <div class="icon-text">余额充值</div>
        </div>

        <div class="grille-item" @click="realNameRegister">
          <div class="img-1">
            <img src="@/assets/newUser/3_1.png" alt="">
          </div>
          <div class="icon-text">实名认证</div>
        </div>

        <div class="grille-item" @click="activeSim">
          <div class="img-1">
            <img src="@/assets/newUser/30_1.png" alt="">
          </div>
          <div class="icon-text">一键复机</div>
        </div>


        <div class="grille-item" @click="toBuyAdd()">
          <div class="img-1">
            <img src="@/assets/newUser/1_1.png" alt="">
          </div>
          <div class="icon-text">加油包</div>
        </div>

        <div v-if="isShowVipMenu == true" class="grille-item" @click="toVipPower()">
          <div class="img-1">
            <img src="@/assets/home/26.png" alt="">
          </div>
          <div class="icon-text">会员抽奖</div>
        </div>

        <div v-else class="grille-item" @click="tousu()">
          <div class="img-1">
            <img src="@/assets/newUser/36.png" alt="">
          </div>
          <div class="icon-text">投诉商家</div>
        </div>

        <div class="grille-item" @click="tousuBack()">
          <div class="img-1">
            <img src="@/assets/newUser/34.png" alt="">
          </div>
          <div class="icon-text">申请注销</div>
        </div>


        <!-- <div v-else class="grille-item" @click="pkgListVisible = true">
          <div class="img-1">
            <img src="@/assets/newUser/34_1.png" alt="">
          </div>
          <div class="icon-text">套餐详情</div>
        </div> -->

        <div class="grille-item" @click="kfClick">
          <div class="img-1">
            <img src="@/assets/newUser/32_1.png" alt="">
          </div>
          <div class="icon-text">联系客服</div>
        </div>

        <!-- <div class="grille-item" @click="autoPkg">
          <div class="img-1">
            <img src="@/assets/newUser/35.png" alt="">
          </div>
          <div class="icon-text">自动续费</div>
        </div> -->
        <div class="grille-item" v-if="simInfo.vipMenu == 1" @click="vipLink">
          <div class="img-1">
            <img src="@/assets/newUser/36.png" alt="">
          </div>
          <div class="icon-text">参与会员</div>
        </div>

        <div class="grille-item" @click="toKefu">
          <div class="img-1">
            <img src="@/assets/newUser/32_1.png" alt="">
          </div>
          <div class="icon-text">备用客服</div>
        </div>

        <div class="grille-item" @click="gotoMore">
          <div class="img-1">
            <img src="@/assets/newUser/4_1.png" alt="">
          </div>
          <div class="icon-text">更多</div>
        </div>

      </div>
    </div>

    <div class="allowance w">
      <div class="t">
        <div class="hit">热门活动 | </div>
        <div class="hit1"> 热门畅销 为你精选</div>
      </div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item @click="kfClick">
          <img src="@/assets/home/tui1.png" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-dialog v-model="show" title="实名认证提示" :show-confirm-button="false">

      <div class="dialog-text">
        根据国家规定，手机卡需要进行实名认证，实名认证后即可畅享网络。
      </div>


      <div class="dialog-text">
        <!-- 如果您已操作实名认证，无需重复操作，状态更新延迟2小时左右，您可直接重启手机使用。 -->
        如果您已操作实名认证，请您联系 在线客服 进行核实处理。避免卡后续未实名而导致停机。
      </div>


      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="closeShow">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="realNameRegister">立即实名</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="reacheShow" title="套餐订购提示" :show-confirm-button="false">
      <div class="dialog-text">您还没有订购套餐，订购套餐后即可畅享网络。若已订购套餐，点击页面中的一键复机后，重启手机即可畅享网络。</div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="closeReacheShow">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toBalanceRecharge">立即订购</van-button>
      </div>
    </van-dialog>



    <van-dialog v-model="isShowApp" title="APP下载提醒" :show-confirm-button="false">
      <div class="dialog-text">
        APP全新优惠来袭！购买套餐随机立减金额等着你！更多优惠请下载APP即可享受。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="closeApp">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toLoadApp">前往下载</van-button>
      </div>
    </van-dialog>



    <van-dialog v-model="isShowHuan" title="换卡提醒" :show-confirm-button="false">
      <div class="dialog-text">
        经系统检测，由于运营商系统故障，请更换新卡使用，新卡套餐不变，已购买套餐会自动转移新卡，费用也会自动转移。
      </div>
      <div class="dialog-text">
        收到新卡后可联系客服咨询激活使用，请放心申请。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="kfClick">联系客服</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toHuanJa">前往换卡</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="canChangeCard" title="换卡提醒" :show-confirm-button="false">
      <div class="dialog-text">
        经系统检测，由于运营商系统故障，请更换新卡使用，新卡套餐不变，已购买套餐会自动转移新卡，费用也会自动转移。
      </div>
      <div class="dialog-text">
        收到新卡后可联系客服咨询激活使用，请放心申请。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="kfClick">联系客服</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toHuanJa">前往换卡</van-button>
      </div>
    </van-dialog>




    <van-dialog v-model="toChangeCmcc" title="故障通知" :show-confirm-button="false">
      <div class="dialog-text">
        由于运营商故障，此卡不能继续使用，可联系客服咨询详情免费更换中国移动号卡，激活后可领取话费。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="closeApp">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="kfClick()">联系客服</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="toYouhuiFlg" title="参与优惠提醒" :show-confirm-button="false">
      <div class="dialog-text">您还没有参与优惠活动，暂无法其它操作，请参与优惠后再来查询。</div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="kfClick()">联系客服</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toYouhui()">参与优惠</van-button>
      </div>
    </van-dialog>

    <van-dialog v-model="isCanBuyPkg" title="流量充足" :show-confirm-button="false">
      <div class="dialog-text">{{ pkgContext }}</div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="isCanBuyPkg = false">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="isCanBuyPkg = false">确认</van-button>
      </div>
    </van-dialog>



    <!--  更多 在用套餐  -->
    <van-popup v-model="pkgListVisible" closeable position="bottom" style="min-height: 35%; max-height: 75%">
      <div class="pkgList">
        <h3 v-if="simInfo.simPackageList && simInfo.simPackageList.length > 0" class="bigTitle">在用套餐:</h3>
        <h3 v-else style="color: red">
          当前暂未订购套餐
        </h3>

        <ul>
          <li v-for="item in simInfo.simPackageList" :key="item.id">
            <p>{{ item.packageName }}</p>
            <div>
              <p>生效时间： {{ item.startTime }}</p>
              <p v-if="new Date(
                getDateByTimeStr(item.endTime)[0],
                getDateByTimeStr(item.endTime)[1],
                getDateByTimeStr(item.endTime)[2],
                getDateByTimeStr(item.endTime)[3],
                getDateByTimeStr(item.endTime)[4],
                getDateByTimeStr(item.endTime)[5]
              ) < new Date()" style="color: red">
                过期时间： {{ item.endTime }}
              </p>
              <p v-else>过期时间： {{ item.endTime }}</p>
            </div>
          </li>
        </ul>

        <h3 v-if="simInfo.simNextPackageList && simInfo.simNextPackageList.length > 0" class="bigTitle">次月套餐:</h3>
        <h3 v-else style="color: red">
          当前暂未订购次月套餐
        </h3>
        <ul>
          <li v-for="item in simInfo.simNextPackageList" :key="item.id">
            <p>{{ item.packageName }}</p>
            <div>
              <p>生效时间： {{ item.startTime }}</p>
              <p v-if="new Date(
                getDateByTimeStr(item.endTime)[0],
                getDateByTimeStr(item.endTime)[1],
                getDateByTimeStr(item.endTime)[2],
                getDateByTimeStr(item.endTime)[3],
                getDateByTimeStr(item.endTime)[4],
                getDateByTimeStr(item.endTime)[5]
              ) < new Date()" style="color: red">
                过期时间： {{ item.endTime }}
              </p>
              <p v-else>过期时间： {{ item.endTime }}</p>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>

    <van-dialog v-model="isShowVip" title="" :show-confirm-button="false" class="vipDialog" overlayClass="v-overlay">
      <div class="dialog-text" @click="vipLink">
        <img src="@/assets/home/36.png" alt="">
      </div>
      <van-icon name="close" color="#fff" size="1.5rem" @click="canCelBack()" />
    </van-dialog>


    <van-dialog v-model="showCardNo" class="popup1" :show-confirm-button="false">
      <div class="popup-title">切换卡板</div>
      <div class="iccid-list">
        <template v-if="dataList.length > 0">
          <div class="iccid-items" :class="{ 'active': activeObj.cardNo === item.cardNo }" v-for="item in dataList"
            :key="item.cardNo" @click="change(item)">{{ item.cardNo }}</div>
        </template>
        <van-empty description="暂无数据" image="network" v-else />
      </div>
      <div class="popup-btn">
        <div class="popupClose" @click="showCardNo = false">取消</div>
        <div class="popupSave" @click="save" v-if="dataList.length > 0">确认</div>
      </div>
    </van-dialog>

    <van-dialog v-model="isShowTui" title="" :show-confirm-button="false" class="vipDialogtui"
      overlayClass="v-overlaytui">
      <div class="dialog-text" @click="toKfClick">
        <img src="@/assets/home/tui.png" alt="" style="width: 100%;height: 100%;">
      </div>
      <van-icon name="close" color="#fff" size="1.5rem" @click="canCelBack()" />
    </van-dialog>

  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
import mixins from '@/mixins/mixins.js'
export default {
  data() {
    return {
      isCanBuyPkg: false,
      toYouhuiFlg: false,
      isShieldAgent: localStorage.getItem('isShieldAgent') == 1 ? true : false,
      toChangeCmcc: false, //超80G换卡 
      isShowTui: false, //是否展示推广有礼弹窗
      isShowVipMenu: false,
      showCardNo: false,
      dataList: [],
      activeObj: {},
      isShowVip: false, ///是否展示VIP弹窗
      isShowHuan: false,
      isShowAppMenu: false,
      isShowApp: false,
      pkgListVisible: false,
      canChangeCard: false,
      userAccount: {},
      simInfo: {},
      show: false,
      reacheShow: false,
      toBugPkg: false,
      isShow: true,
      recordLoginText: localStorage.getItem('recordLoginText'),
      basePkgGroup: localStorage.getItem('basePkgGroup'),
      iccid: localStorage.getItem('iccid'),
      alreadyHasAccount: false,

      pkgContext: '您的套餐流量充足，暂无需重复购买套餐。'
    }
  },
  mixins: [mixins],
  async created() {
    // localStorage.setItem("iccid","898604B0262180273067");
    // this.$store.state.iccid="898604B0262180273067";
    localStorage.setItem("isShowVip", false); // 做缓存，用于Checkstand.vue支付栏判断
    await this.getInfo()
    await this.init()
    await this.getAccount()
    this.dataList = []
    wxRequest('sim/iccidList/userPhone', { userPhone: localStorage.getItem("userPhone") }, 'post').then((res) => {
      if (res.data.code === '200') {
        this.dataList = res.data.data
      } else {
        Toast.fail(res.data.message)
      }
    })
  },
  methods: {
    toKefu() {
      window.location.href = 'http://guanwang.szyanyun.com/s/93990rn4q';
    },
    tousuBack() {
      this.$router.push({
        path: '/newUser/tousuBack',
        query: {
          iccid: this.$store.state.iccid,
        }
      })
    },
    tousu() {
      this.$router.push({
        path: '/newUser/entrance',
        query: {
          iccid: this.$store.state.iccid,
          isAdd: 1
        }
      })
    },
    toBuyAdd() {
      this.$router.push({
        path: '/user/recharge',
        query: {
          iccid: this.$store.state.iccid,
          isAdd: 1
        }
      })
    },
    canCelBack() {
      this.isShowTui = false;
      this.isShowVip = false;
      localStorage.setItem("firstVipLogin", 1);

    },
    toVipPower() {
      this.$router.push({
        path: '/user/luckDraw'
      })
    },
    toHuanJa() {
      window.location.href = 'http://wx.519liuliang.com/#/user/userChgCard';
    },
    closeApp() {
      this.canChangeCard = false;
      this.toChangeCmcc = false;
      this.isShowHuan = false;
      localStorage.setItem("isShowApp", 0);
      this.isShowApp = false;
    },
    toLoadApp() {
      localStorage.setItem("isShowApp", 0);
      this.isShowApp = false;
      this.$router.push({
        path: '/user/AppLoad'
      })
    },
    autoPkg() {
      this.$router.push({
        path: '/user/renew'
      })
    },
    getDateByTimeStr(timeStr) {
      if (timeStr && typeof timeStr === "string") {
        let dayStr = timeStr.split(" ")[0].split("-");
        let hourStr = timeStr.split(" ")[1].split(":");
        return dayStr.concat(hourStr);
      }
      return timeStr;
    },

    outLogin() {
      this.$router.push({
        path: "/newUser/problem",
      });
    },
    reloadSim() {
      let data = {
        iccid: this.simInfo.iccid,
      };
      wxRequest("sim/to/reload", data, "get").then((res) => {
        if (res.data.code == 200) {
          Dialog.alert({
            title: "提示",
            message: "刷新成功，请打开飞行模式一下即可",
          });
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },
    toKfClick() {
      localStorage.setItem("firstVipLogin", 1);
      this.kfClick();
    },
    kfClick() {
      var isToWxKefu = localStorage.getItem("isToWxKefu");
      if (isToWxKefu && isToWxKefu == 1) {
        window.location.href = 'https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL'
      } else {
        window.location.href = 'https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL'
      }
    },
    activeSim() {
      let data = {
        iccid: this.simInfo.iccid,
      };
      Dialog.confirm({
        title: "提示",
        message:
          "请您确保当前卡已完成实名认证并且拥有套餐 方可复机。复机完成后 打开飞行模式一下即可！",
      })
        .then(() => {
          wxRequest("sim/to/active", data, "get").then((res) => {
            Dialog.alert({ title: "提示", message: res.data.message });
          });
        })
        .catch(() => { });
    },
    black(index) {
      this.$router.push({
        path: '/newUser/firstHome'
      })
    },
    toAddSim() {
      this.$router.push({ path: "/newUser/bindNew/bindingCard", query: { noCode: 1 } }) //noCode 新增卡板时
    },
    change(data) {
      this.activeObj = data
    },
    popupShow() {
      wxRequest('sim/iccidList/userPhone', { userPhone: localStorage.getItem('userPhone') }, 'post').then((res) => {
        this.activeObj = res.data.data;
      })
      this.showCardNo = true
    },
    toYouhui() {
      this.$router.push({ path: "/newUser/bindNew/bindPhone", query: {} });
    },
    //切换卡板
    save() {
      this.$router.push({ path: "/newUser/bindNew/bindPhone", query: { newCardNo: this.activeObj.cardNo } });
      // this.init()
      this.showCardNo = false
    },
    init() {
      const fd = new FormData()
      let cardTypeStr = '电信'
      fd.append('iccid', this.iccid)
      wxRequest('/applyChangeSim/isChange', fd, 'post').then((res) => {
        if (res.data.code === '200') {
          this.canChangeCard = true
          // if (res.data.data) {
          //   cardTypeStr = res.data.data.cardType === 0 ? '移动' : res.data.data.cardType === 1 ? '电信' : '联通'
          // }
          // // 公司本部公众号
          // if (localStorage.getItem('isHeadquarterAppid')) {
          //   Dialog.alert({
          //     title: '提示',
          //     messageAlign: 'left',
          //     message:
          //       '尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，我司将免费给您更换网速良好的新卡使用，请填写好您的联系方式和地址，原卡套餐流量将会转移到新卡，感谢您一直以来的支持 ！'
          //   }).then((action) => {
          //     let cardBeLack = '移动'
          //     if (cardTypeStr === '移动') {
          //       cardBeLack = '电信'
          //     }
          //     Dialog.confirm({
          //       title: '提示',
          //       message:
          //         '目前移动卡充足，其他卡缺货(发货时间可能较长)，您确定要换卡吗？'
          //     }).then((action) => {
          //       if (action === 'confirm') {
          //         window.location.href =
          //           'http://webchat.szxxtx.com/#/user/chgCardQuery'
          //       }
          //     })
          //       .catch(() => { })
          //   })
          // } else {
          //   Dialog.alert({
          //     title: '提示',
          //     messageAlign: 'left',
          //     message:
          //       '尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，请联系您的经销商，谢谢！'
          //   })
          // }
        } else {
          if (this.simInfo.basePkgGroup != '1777588250030895104') {
            wxRequest('/sim/is/have/price', { iccid: this.iccid }, 'get').then((res) => {
              if (res.data.code === '200' || res.data.code === 200) {
                wxRequest('/sim/is/have/pkgs', { iccid: this.iccid }, 'get').then((res) => {
                  if (res.data.code === '200') {
                    if (this.isShowHuan == false) {
                      this.supplierAuthHeald(this.iccid, res.data)
                    }
                  } else {
                    var showImgData = localStorage.getItem('showImgData' + this.iccid);
                    if (!showImgData) {
                      this.reacheShow = true;
                      localStorage.setItem('showImgData' + this.iccid, '1s');
                    }
                  }
                }
                )
              } else {
                this.toYouhuiFlg = false;

              }
            }
            )



          }

        }
      })
    },
    supplierAuthHeald(iccid, data) {
      var firstVipLogin = localStorage.getItem("firstVipLogin");
      wxRequest('/wxAuth/supplierAuth', { iccid: iccid }, 'post').then((res) => {
        if (res.data.code !== '200') {
          var isToloadAuth = localStorage.getItem("isToloadAuth");
          if (!isToloadAuth) {
            this.show = true
          }
        } else if (this.simInfo.isShowVip > 0) {
          this.isShowVipMenu = true;
          if (firstVipLogin == 0) {
            this.isShowVip = true; //home页面 是否弹VIP框
          }
          localStorage.setItem("isShowVip", true); // 做缓存，用于Checkstand.vue支付栏判断
        } else {
          localStorage.setItem("isShowVip", false); // 做缓存，用于Checkstand.vue支付栏判断
          // this.isShowAppMenu = localStorage.getItem('isShowAppMenu') == 1 ? true : false
          if (firstVipLogin == 0) {
            this.isShowTui = true;// 是否弹推广弹窗
          }
        }
      })
    },
    //购买VIP会员
    vipLink() {
      localStorage.setItem("firstVipLogin", 1);
      this.$router.push({ path: "/user/userAgreement" });
    },
    closeShow() {
      this.show = false
    },
    immediately() {
      if (
        this.simInfo.supplierTypeCode === 1 ||
        this.simInfo.supplierTypeCode === 5
      ) {
        window.location.href =
          'http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504'
      } else {
        window.location.href =
          'https://env-9gk22lag4fab0241-1309553396.tcloudbaseapp.com/jump-mp.html'
      }
      this.closeShow()
    },
    closeReacheShow() {
      this.reacheShow = false
      this.toBugPkg = false
    },
    order() {
      this.$router.push({
        name: 'recharge'
      })
      this.closeReacheShow()
    },
    // 实名判断及移动联通卡判断
    realNameRegister() {
      if (this.simInfo.supplierCode == '1846450146708025344') {
        localStorage.setItem("isToloadAuth", "1s")
      }
      const iccid = localStorage.getItem('iccid')
      wxRequest('sim/is/have/pkgs', { iccid: iccid }, 'get').then((res) => {
        const types = res.data.data
        if (res.data.code === '200') {
          wxRequest('wxAuth/supplierAuth', { iccid: iccid }, 'post').then(
            (res) => {
              if (res.data.code !== '200') {
                if (types === 49) {
                  this.$router.push({
                    path: '/user/cuccToAuth',
                    query: {
                      state: this.state,
                      supplierTypeCode: this.simInfo.supplierTypeCode
                    }
                  })
                } else {
                  if (types === 49) {
                    this.$router.push({
                      path: '/user/cuccToAuth',
                      query: {
                        state: this.state,
                        supplierTypeCode: 49
                      }
                    })
                  } else if (types === 3) {
                    // 移动
                    const data = {
                      iccid: localStorage.getItem('iccid')
                    }
                    wxRequest('sim/get/cmcc/auth', data, 'get').then(
                      (res) => {
                        if (res.data.code === '200') {
                          window.location.href = res.data.data
                        } else {
                          Dialog.alert({
                            title: '提示',
                            message: res.data.message
                          })
                        }
                      }
                    )
                    //广电
                  } else if (types === 7 || types === 8 || types === 9) {
                    this.$router.push({
                      path: '/user/guangdianAuth',
                      query: {
                      }
                    })
                  } else {
                    window.location.href =
                      'http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504'
                  }
                }
              } else {
                Dialog.alert({
                  title: '实名提示',
                  message: '已实名'
                })
              }
            }
          )
        }
      })
    },
    getAccount() {
      const param = {
        iccid: this.iccid,
        mobile: localStorage.getItem('mobile')
      }
      localStorage.setItem('userSimAmount', 0)
      // 若为总部微信公众号
      if (localStorage.getItem('isHeadquarterAppid')) {
        wxRequest('/sysUser/account/querySysUserAccount', param, 'post').then(
          (res) => {
            if (res.data.code === '200') {
              this.userAccount = res.data.data
              localStorage.setItem('userSimAmount', this.userAccount.amount)
              this.alreadyHasAccount = true
            } else if (res.data.code === '400') {
              const self = this
              if (self.$store.state.supplierCode === '1197749413972275200') {
                Dialog.confirm({
                  title: '提示',
                  message: '首次使用需进行充值，请点击【确认】前往充值'
                })
                  .then(() => {
                    self.$router.replace('/newUser/recharge')
                  })
                  .catch(() => { })
              }
            }
          }
        )
      } else {
        // 若为代理商公众号
        wxRequest('/sysUser/account/querySysUserAccount', param, 'post').then(
          (res) => {
            if (res.data.code === '200') {
              this.userAccount = res.data.data
              this.alreadyHasAccount = true
            }
          }
        )
      }
    },
    getInfo() {
      wxRequest('sim/detail', { iccid: this.iccid }, 'post').then((res) => {
        if (res.data.code === '200') {
          this.simInfo = res.data.data
          if (this.simInfo.basePkgGroup == '1777588250030895104') {
            this.toChangeCmcc = true;
          }

          if (this.simInfo.showToHuan == 1) {
            this.isShowHuan = true;
          }
          if (this.simInfo.isVip > 0) {
            this.isShowVipMenu = true;
          }
          //画流量仪表盘
          let progressRate = 0;
          progressRate = this.simInfo.usedFlowRate ? Math.floor((this.simInfo.usedFlowRate / this.simInfo.flowRate) * 100) : 0;
          let fz = 40;
          if (progressRate == 100) {
            fz = 30;
          }
          this.drawProgressBar("home_progressBar", progressRate, 3, "#ECF4FF", ["#4792FF", "rgb(25, 137, 250)"], 85, fz, "inner");

        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    gotodiv() {
      this.$router.replace('/newUser/diagnosis')
    },
    toRecharge() {
      this.$router.replace('/newUser/recharge')
    },
    detailsTo() {
      this.$router.push({
        path: '/newUser/deposit',
        query: {
          iccid: this.iccid
        }
      })
    },
    gotoMore() {
      this.$router.push({
        path: '/newUser/operation'
      })
    },
    toBalanceRecharge() {
      // if (this.simInfo.endTimeDay >= 7 && this.simInfo.surplusFlowRate > 1024 * 15) {
      //   if (this.simInfo.basePkgGroup == '1784398969212760064' || this.simInfo.basePkgGroup == '1790294950382923776' || this.simInfo.basePkgGroup == '1791396471208144896') {
      //     this.pkgContext = "您的套餐还剩余" + this.simInfo.endTimeDay + "天，剩余流量大于15G，暂无需再次购买套餐。请在套餐到期剩余7天内 再来订购次月套餐。"
      //     this.isCanBuyPkg = true;
      //     return;
      //   } else if (this.simInfo.basePkgGroup == '1808758033149325312'||this.simInfo.basePkgGroup == '1808751149325312') {
      //     this.pkgContext = "您的套餐还剩余" + this.simInfo.endTimeDay + "天，目前套餐到期时间充足。 请在26号后再来续费次月套餐使用"
      //     this.isCanBuyPkg = true;
      //     return;
      //   }
      // }  else

      // if (this.simInfo.basePkgGroup == '1817882838058397692' || this.simInfo.basePkgGroup == '1817882838058397696') {
      //   if (this.simInfo.endTimeDay >= 3 && this.simInfo.surplusFlowRate > 1024 * 15) {
      //     this.pkgContext = "您的套餐目前套餐到期时间充足。 请在到期3天内再来充值次月套餐"
      //     this.isCanBuyPkg = true;
      //     return;
      //   }
      // } 

      // if (this.simInfo.endTimeDay > 6 && this.simInfo.surplusFlowRate > 1024 * 15 && this.simInfo.basePkgGroup == '1863432399233216512') {
      //   this.pkgContext = "您的套餐目前套餐到期时间充足,暂无需订购套餐"
      //   this.isCanBuyPkg = true;
      //   return;
      // }else  if (this.simInfo.endTimeDay > 3 && this.simInfo.surplusFlowRate > 1024 * 15 && this.simInfo.basePkgGroup == '1871053480697786368') {
      //   this.pkgContext = "您的套餐目前套餐到期时间充足,暂无需订购套餐"
      //   this.isCanBuyPkg = true;
      //   return;
      // }

      // 若为总部微信公众号
      if (localStorage.getItem('isHeadquarterAppid')) {
        const fd = new FormData()
        fd.append('supplierId', sessionStorage.getItem('supplierCode'))
        wxRequest('sim/invent/state', fd, 'post').then((res) => {
          if (res.data.code === '200') {
            if (this.userAccount.amount < 0) {
              Dialog.confirm({
                title: '提示',
                message: '您的账户余额已透支，请先充值账户余额！'
              })
                .then(() => {
                  this.$router.push({
                    path: '/user/balanceRecharge',
                    query: {
                      iccid: this.$store.state.iccid
                    }
                  })
                })
                .catch(() => { })
            } else {
              this.$router.push({
                path: '/user/recharge',
                query: {
                  iccid: this.$store.state.iccid,
                  isAdd: 2
                }
              })
            }
          } else {
            Dialog.alert({ title: '提示', message: res.data.message })
          }
        })
      } else {
        // 若为代理商微信公众号
        this.$router.push({
          path: '/user/recharge',
          query: {
            iccid: this.$store.state.iccid,
            isAdd: 2
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
div {
  display: flex;
  flex-grow: 0;
  flex-basis: auto;
  align-items: stretch;
  flex-direction: column;
}

.flowInfo {
  position: relative;
  margin-top: 20px;
  text-align: center;
  margin-bottom: 16px;
}

#home_progressBar {
  position: absolute;
  width: 14.5rem;
  height: 14.5rem;
  top: -25px;
  left: calc(50% - 7.25rem);
}

.w {
  width: 90%;
}

.vipDialog {
  background: none;
  width: 100%;

  ::v-deep .van-dialog__content {
    background: none !important;
    padding: 0 !important;
    text-align: center;
    width: 100%;

    .van-icon-close {
      /* position: absolute; */
      margin-top: 20px;
    }
  }
}

.vipDialogtui {
  background: none;
  width: 100%;

  ::v-deep .van-dialog__content {
    background: none !important;
    padding: 0 !important;
    text-align: center;
    width: 100%;

    .van-icon-close {
      /* position: absolute; */
      margin-top: 20px;
    }
  }
}

::v-deep .v-overlay {
  background: #000;
}

.page {
  background: #f7f8fa url("../../assets/newUser/h_bg.png") no-repeat;
  background-position: 0% 0%;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 20px;
  height: calc(100% - 20px);

  .t-bg {
    background-image: linear-gradient(#3980F9, #fff);
  }

  .top-back {
    flex-direction: row;
    align-items: center;
    height: 77px;
    display: flex;
    text-align: center;
    color: #FFFFFF;
    margin: 0 10px;
    justify-content: space-between;

    .back {
      align-items: center;
      width: 116px;

      img {
        width: 100%;
      }
    }

    .code {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      font-weight: 600;

      .addOrChange {
        flex-direction: row;
        justify-content: end;
        align-items: center;
        margin-top: 4px;
        position: relative;
        font-weight: 400;
        z-index: 9;

        .u-switch {
          color: #fff;
          font-size: 12px;
          line-height: 28px;
          font-family: PingFangSC, PingFang SC;
          width: 64px;
          height: 26px;
          text-align: center;
          justify-content: center;
          border-radius: 4px;
          border: 1px solid #CACACA;
          margin-left: 10px;
        }

        div {
          flex-direction: row;
          align-items: center;
        }
      }
    }
  }

  .grille {
    display: flex;
    align-self: center;
    flex-direction: row;
    margin: 10px auto;
    background-color: #fff;
    border-radius: 16px;
    align-content: flex-start;
    flex-wrap: wrap;
    width: 95%;

    .grille-item {
      width: 25%;
      margin: 10px 0px 10px;
      align-items: center;

      .img-1 {
        width: 40px;
        height: 40px;
      }

      .icon-text {
        font-size: 12px;
        color: #333;
        margin-top: 8px;
      }
    }
  }

  .van-top {
    padding: 13px 10px;
    width: 90%;
    display: block;

    .t-f {
      justify-content: space-between;
      flex-direction: row;
      width: 100%;
      flex: 1;

      .t-l,
      .t-r {
        flex-direction: row;
        align-items: center;
      }

      .t-r {
        color: #999;

        span {
          color: #333333;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          padding-left: 6px;
          font-weight: bold;
        }
      }

      .t-rRed {
        color: #999;

        span {
          color: red;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          padding-left: 6px;
          font-weight: bold;
        }
      }

      .t-l {
        span {
          display: inline-block;

          &:first-child {
            /* width: 56px; */
            height: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 15px;
            color: #333333;
            line-height: 20px;
            margin-right: 7px;

            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 13px;
              color: #397EF5;
              text-align: center;
              line-height: 17px;
            }
          }
        }
      }
    }

    .total-liu {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      padding-bottom: 6px;
      border-bottom: 1px solid #EDEDED;

      .l-l {
        display: block;
        color: #333333;
        font-size: 14px;

        span {
          height: 17px;
          font-family: HarmonyOS_Sans_SC_Bold;
          ;
          font-size: 16px;
          color: #FA0E10;
          line-height: 17px;
          padding-left: 4px;
        }
      }
    }

    .user-price {
      margin-top: 18px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 9;

      .price-l {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        background: url('~@/assets/newUser/yur.png') no-repeat center left;
        background-size: 20px 20px;
        padding-left: 28px;
      }

      .price-r {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .text-num {
          font-family: HarmonyOS_Sans_SC_Bold;
          font-size: 14px;
          color: #333333;
          line-height: 19px;
        }

        .text-link {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #397EF5;
          line-height: 20px;
          text-decoration-line: underline;
        }
      }
    }
  }

  .allowance {
    align-self: center;
    flex-direction: column;
    margin-top: 15px;
    justify-content: center;
    background: #fff;
    border-radius: 20px;
    padding: 10px;
    /* width: 87%; */

    .balanceBox {
      display: flex;
      flex-direction: column;
      // background: #f7f8fa;
      border-radius: 8px;
      position: relative;
      margin-top: 5px;
      padding: 0 15px 15px;

      .balance-item {
        flex: 1;
        display: flex;
        flex-direction: row;
        margin-top: 15px;

        .balance-icon {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }

        .text12-div {
          flex: 1;
        }

        .text-num {
          font-size: 13px;
          color: #06121e;
          font-weight: 700;
        }

        .text-link {
          font-size: 13px;
          font-weight: 500;
          color: #1c96f6;
          text-decoration: underline;
          margin-left: 15px;
        }
      }
    }

    .btn-link {
      height: 46px;
      width: 90%;
      margin: 0 auto;
      line-height: 46px;
      text-align: center;
      border-radius: 26px;
      background: #397EF5 url('../../assets/newUser/52.png') no-repeat 60px center;
      background-size: 19px 22px;
      color: #fff;
    }

    .t {
      display: flex;
      flex-direction: row;
      width: 320px;
      align-items: center;
      margin-bottom: 16px;

      .t-img {
        width: 26px;
        height: 26px;
      }

      .hit {
        color: #333;
        font-weight: 500;
        font-size: 14px;
      }

      .hit1 {
        color: #999;
        font-size: 14px;
        padding-left: 10px;
      }
    }

    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 91px;
      height: 91px;
      text-align: center;
    }
  }
}

.residue-flow {
  padding-top: 10px;

  p:first-child {
    padding-top: 30px;
    font-size: 38px;
  }

  p:last-child {
    line-height: 18px;
  }
}

.van-dialog,
.van-popup {
  ::v-deep.van-dialog__content {
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }

  ::v-deep .van-dialog__header {
    font-size: 20px;
    font-weight: 700;
    color: #06121e;
    text-align: center;
    margin-bottom: 10px;
  }

  .dialog-text {
    font-size: 14px;
    color: #06121e;
    margin-top: 8px;
    line-height: 28px;
  }

  .btn-vis {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;

    .dialog-btn2 {
      width: 120px;
      height: 47px;
      color: #3476fe;
      text-align: center;
      background: rgba(52, 118, 254, 0.1) !important;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
    }

    .dialog-btn3 {
      width: 130px;
      height: 47px;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
      border: 0;
      color: #fff;
      background: #3476fe;
      text-align: center;
    }
  }

  .pkgList {
    padding: 10px 20px;

    h3 {
      margin-top: 20px;
      font-size: 14px;
      line-height: 28px;
      font-weight: bold;
    }

    ul {
      line-height: 38px;

      li {
        display: flex;
        justify-content: space-between;

        >p {
          display: flex;
          align-items: center;
        }

        >div {
          p {
            line-height: 18px;
            font-size: 12px;
          }
        }
      }
    }
  }

}

.van-empty {
  align-items: center;
}

.popup1 {
  ::v-deep .van-dialog__content {
    width: 100%;
    height: 400px;
    border-radius: 10px;
    padding: 0;

    .popup-title {
      height: 29px;
      background: url('../../assets/img/top-bg.png') no-repeat center center;
      background-size: 100% 100%;
      text-align: center;
      font-size: 19px;
      font-weight: 600;
      padding-top: 22px;
    }

    .iccid-list {
      height: 275px;
      overflow: auto;

      .iccid-items {
        margin: 0 13px;
        margin-top: 13px;
        text-align: center;
        height: 60px;
        border: 1px solid #EEF4FF;
        border-radius: 10px;
        line-height: 60px;
        color: #94959A;
        font-size: 14px;
      }

      .active {
        border: 1px solid #50A9FF;
      }
    }

    .popup-btn {
      display: flex;
      margin: 0 14px;
      margin-top: 13px;
      flex-direction: row;
      justify-content: center;

      div {
        width: 121px;
        height: 44px;
        border-radius: 7px;
        font-size: 15px;
        text-align: center;
        line-height: 44px;
      }

      .popupClose {
        background: #F5F5F5;
        color: #666666;
      }

      .popupSave {
        color: #fff;
        background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
        margin-left: 10px;
      }
    }
  }
}

.v-btn {
  display: flex;
  margin: auto;
  width: 90%;
  background: #fff;
  border-radius: 16px;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  justify-content: space-between;

  .btn-left {
    flex-direction: row;
    display: flex;
    align-items: center;

    .van-icon {
      color: #d86304;
      margin-right: 10px;
    }

    .n-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 6px;
    }

    .n-small {
      font-size: 12px;
      color: #666;
    }
  }
}</style>

